import React from "react";
import { ChevronRight } from "lucide-react";
import BottomSheet from "./bottom-sheet";
import { cn } from "../../lib/utils";

export interface ActionSheetItem {
  label: string;
  icon?: React.ComponentType<{ className?: string }>;
  onClick: () => void;
  destructive?: boolean;
  disabled?: boolean;
}

interface ActionSheetProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions: ActionSheetItem[];
}

const ActionSheet: React.FC<ActionSheetProps> = ({
  open,
  onClose,
  title,
  description,
  actions,
}) => (
  <BottomSheet open={open} onClose={onClose} title={title} description={description}>
    <div className="px-4 pb-4">
      <div className="overflow-hidden rounded-2xl border border-gray-100">
        {actions.map((action) => (
          <button
            key={action.label}
            type="button"
            disabled={action.disabled}
            onClick={() => {
              onClose();
              action.onClick();
            }}
            className={cn(
              "flex w-full items-center gap-3 border-0 border-b border-gray-100 bg-white px-4 py-3.5 text-left last:border-b-0 active:bg-gray-50 disabled:opacity-40",
              action.destructive ? "text-red-600" : "text-gray-800",
            )}
          >
            {action.icon && (
              <span
                className={cn(
                  "flex h-9 w-9 shrink-0 items-center justify-center rounded-xl",
                  action.destructive ? "bg-red-50" : "bg-gray-50",
                )}
              >
                <action.icon className="h-[18px] w-[18px]" />
              </span>
            )}
            <span className="flex-1 text-sm font-medium">{action.label}</span>
            <ChevronRight className="h-4 w-4 text-gray-300" />
          </button>
        ))}
      </div>
    </div>
  </BottomSheet>
);

export default ActionSheet;
